// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TransactionQuickLinks_ql__MbsuT {
  width: 100%;
  border-radius: 2rem;
  background-color: var(--color-primary-3);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 3.5rem 2rem;
}
@media only screen and (max-width: 37.5em) {
  .TransactionQuickLinks_ql__MbsuT {
    grid-column: 1/2;
    grid-row: 2/3;
    width: 95%;
    justify-self: center;
  }
}
.TransactionQuickLinks_ql__content__ErON5 {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  box-sizing: border-box;
  gap: 2rem;
  margin-top: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Transactions/TransactionQuickLinks.module.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EACA,mBAAA;EACA,wCAAA;EACA,4CAAA;EACA,sBAAA;EACA,oBAAA;AADD;AAEC;EAPD;IAQE,gBAAA;IACA,aAAA;IACA,UAAA;IACA,oBAAA;EACA;AACF;AACC;EACC,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.ql {\n\twidth: 100%;\n\tborder-radius: 2rem;\n\tbackground-color: var(--color-primary-3);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tbox-sizing: border-box;\n\tpadding: 3.5rem 2rem;\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-column: 1/2;\n\t\tgrid-row: 2/3;\n\t\twidth: 95%;\n\t\tjustify-self: center;\n\t}\n\n\t&__content {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-evenly;\n\t\tbox-sizing: border-box;\n\t\tgap: 2rem;\n\t\tmargin-top: 3rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ql": `TransactionQuickLinks_ql__MbsuT`,
	"ql__content": `TransactionQuickLinks_ql__content__ErON5`
};
export default ___CSS_LOADER_EXPORT___;
